import { render, staticRenderFns } from "./dustbinBox.vue?vue&type=template&id=838cc8be&scoped=true&"
import script from "./dustbinBox.vue?vue&type=script&lang=js&"
export * from "./dustbinBox.vue?vue&type=script&lang=js&"
import style0 from "./dustbinBox.vue?vue&type=style&index=0&id=838cc8be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838cc8be",
  null
  
)

export default component.exports